const translationKeyGenerator = (...args: string[]): string => {
  return args.join('_').toUpperCase()
}

export default translationKeyGenerator
